var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advance-image-swiper"},[_c('swiper',{ref:"img-swiper",class:!_vm.isMobile() && 'swiper-no-swiping',attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.$attrs.dataList),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{staticClass:"img",style:({
          cursor: item.link ? 'pointer' : 'auto',
          '--imgWidth': _vm.imgConf.width
        }),attrs:{"src":item.url},on:{"click":function($event){$event.preventDefault();return _vm.openUrl(item.link)}}})])}),(_vm.pagination.is)?_c('div',{staticClass:"swiper-pagination",style:({
        '--activePageColor': _vm.pagination.curColor,
        '--comPageColor': _vm.pagination.comColor
      }),attrs:{"slot":"pagination"},slot:"pagination"}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }